(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('OpeningProcessController', OpeningProcessController)

    /** @ngInject */
    function OpeningProcessController($rootScope, $scope, ApplicationService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        vm.getImagePath = application => {
            return HelperService.imageHandlerPath('application', application.Id, application.Image);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getApplications() {
            HelperService.startLoading('.applications-list-holder');

            ApplicationService
                .getAllByAccessLevel(3)
                .then(success => {
                    vm.applications = success.filter(x => x.Title.toLowerCase().includes('sgpc'));
                    console.log('vm.applications', vm.applications);

                    HelperService.stopLoading('.applications-list-holder');
                }, error => {
                    HelperService.stopLoading('.applications-list-holder');
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            getApplications();
        }
    }
}());